import { render, staticRenderFns } from "./CashSettlementsDetailsTable.vue?vue&type=template&id=db2d441e&scoped=true&"
import script from "./CashSettlementsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./CashSettlementsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./CashSettlementsDetailsTable.vue?vue&type=style&index=0&id=db2d441e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2d441e",
  null
  
)

export default component.exports